import { CSSProperties } from 'react';
import { FeatureItem, FeatureItemProps } from './FeatureItem';
import { FeatureDetailRows } from './Layer';
import { getLatLongFromGeometry } from './utils/getLatLongFromGeometry';

const SCROLLABLE_STYLE: CSSProperties = {
  maxHeight: '200px',
  overflowY: 'auto',
};

type InternalFeatureListProps = {
  features: Required<NonNullable<FeatureItemProps['internalFeature']>>[];
  onZoomToLocation: (params: {
    longitude: number;
    latitude: number;
    zoom?: number;
  }) => Promise<void> | undefined | void;
  onEdit?: (featureId: string) => Promise<void> | void;
  onDelete?: (featureId: string) => Promise<void> | void;
};

export function InternalFeatureList({
  features,
  onZoomToLocation,
  onEdit,
  onDelete,
}: InternalFeatureListProps) {
  return (
    <ul
      className="list-unstyled mb-0 d-flex flex-column gap-1"
      style={SCROLLABLE_STYLE}
    >
      {features.map((feature) => {
        const coords = getLatLongFromGeometry(feature.geometry);
        if (!coords) return null;

        return (
          <FeatureItem
            key={feature.key}
            internalFeature={feature}
            title={feature.title}
            onZoom={() => onZoomToLocation({ ...coords })}
            onEdit={onEdit}
            onDelete={onDelete}
          >
            <FeatureDetailRows lastUpdated={feature.updatedAt} point={coords} />
          </FeatureItem>
        );
      })}
    </ul>
  );
}
